import request from '@/utils/request'


// 查询用户充值配置列表
export function listRechargeConfig(query) {
  return request({
    url: '/biz/admin/user/recharge/config/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户充值配置分页
export function pageRechargeConfig(query) {
  return request({
    url: '/biz/admin/user/recharge/config/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户充值配置详细
export function getRechargeConfig(data) {
  return request({
    url: '/biz/admin/user/recharge/config/detail',
    method: 'get',
    params: data
  })
}

// 新增用户充值配置
export function addRechargeConfig(data) {
  return request({
    url: '/biz/admin/user/recharge/config/add',
    method: 'post',
    data: data
  })
}

// 修改用户充值配置
export function updateRechargeConfig(data) {
  return request({
    url: '/biz/admin/user/recharge/config/edit',
    method: 'post',
    data: data
  })
}

// 删除用户充值配置
export function delRechargeConfig(data) {
  return request({
    url: '/biz/admin/user/recharge/config/delete',
    method: 'post',
    data: data
  })
}

export function sortDrag(query) {
  return request({
    url: 'biz/admin/user/recharge/config/sort',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}
